import { IMG, LINKS } from "../../data/site";
import { CTA, Eyebrow, Photo, Reveal, TextLink } from "./primitives";

const WAYS = [
  { title: "Online Video Library", text: "Practice at your own pace with access to a collection of yoga, meditation and other guided practices." },
  { title: "Guided Programs", text: "Follow a thoughtfully structured series of classes designed to guide you through a specific practice or experience." },
];

export default function OnlineLibrary() {
  return (
    <section id="online" aria-labelledby="online-title" data-testid="online-section" className="relative scroll-mt-24 overflow-hidden bg-ocean-deep px-6 py-24 text-ivory sm:px-8 lg:px-12 lg:py-36">
      <div aria-hidden className="pointer-events-none absolute -left-40 top-10 h-[520px] w-[520px] rounded-full bg-[radial-gradient(circle,rgba(169,195,200,0.16),transparent_70%)]" />
      <div className="relative mx-auto grid max-w-7xl items-center gap-14 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal>
            <Eyebrow tone="dark">Practice online</Eyebrow>
            <h2 id="online-title" className="mt-5 font-display text-[2.4rem] font-light leading-[1.05] sm:text-5xl lg:text-6xl">
              A Practice You Can Return To
            </h2>
            <p className="mt-6 font-display text-2xl italic leading-snug text-[#F6D2BC] sm:text-[1.7rem]" data-testid="online-lead">
              Whether you have a few minutes or a full hour, these sessions are here to support you so you can move, breathe and reconnect whenever you need it.
            </p>
          </Reveal>
          <Reveal delay={0.1} as="ul" className="mt-9 space-y-5">
            {WAYS.map((w) => (
              <li key={w.title} className="border-t border-ivory/15 pt-5" data-testid={`online-way-${w.title.toLowerCase().replace(/\s+/g, "-")}`}>
                <p className="text-[11px] font-semibold uppercase tracking-[0.26em] text-coral-soft">{w.title}</p>
                <p className="mt-2 text-base leading-relaxed text-ivory/80">{w.text}</p>
              </li>
            ))}
          </Reveal>
          <Reveal delay={0.2} className="mt-10">
            <CTA href={LINKS.practiceOnline} variant="ivory" testid="online-explore-practice-button">
              Explore Practice Online
            </CTA>
          </Reveal>
          <Reveal delay={0.35} className="mt-6 flex items-center gap-3 border-t border-ivory/15 pt-5">
            <span className="text-sm text-ivory/70">Already a member?</span>
            <TextLink href={LINKS.login} light testid="online-member-login-link">
              Member Login
            </TextLink>
          </Reveal>
        </div>

        <Reveal delay={0.1} y={50} className="lg:col-span-7 lg:flex lg:justify-end">
          <div className="overflow-hidden rounded-[2rem] shadow-[0_40px_90px_-40px_rgba(0,0,0,0.7)] lg:w-full lg:max-w-[540px]">
            <div className="aspect-square">
              <Photo img={IMG.library} sizes="(min-width:1024px) 540px, 92vw" className="h-full w-full object-cover" data-testid="online-library-image" />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
